import { useDispatch } from 'react-redux';

import DropdownNumberRange from 'src/components/sellerFlow/DropdownNumberRange';
import { DropdownNumberRangeQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers } from 'src/store/sellerInput';

import { trackAnswerChange } from './trackAnswerChange';

type NumberRangeSelectInputProps = {
  question: DropdownNumberRangeQuestion;
  value: { max_price?: number; min_price?: number };
};

const NumberRangeSelectInput: React.FC<NumberRangeSelectInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();

  const onChange = (_name: string, newValue: { min_price?: number; max_price?: number }) => {
    const answer = { ...value, ...newValue };
    dispatch(changeAnswers([{ key: question.key, answer }]));
    trackAnswerChange(question.key, answer);
  };

  return (
    <DropdownNumberRange
      name={question.key}
      increments={question.increments}
      minLimit={question.minValue}
      maxLimit={
        typeof question.maxValue === 'string' ? parseInt(question.maxValue) : question.maxValue
      }
      value={value}
      onChange={onChange}
    />
  );
};

export default NumberRangeSelectInput;
